import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const BulletinPage = () => {
  const [bulletins, setBulletins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBulletins();
  }, []);

  const fetchBulletins = async () => {
    try {
      const { data } = await axios.get(`${API}/api/bulletins/`);
      setBulletins(data);
    } catch (error) {
      console.error('Failed to fetch bulletins:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0D0D0D] pt-24 px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="animate-spin w-12 h-12 border-4 border-[#D4AF37] border-t-transparent rounded-full mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0D0D0D] pt-24 px-4 pb-20">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            NEWS & UPDATES
          </h1>
          <p className="text-lg text-[#737373]">
            Stay updated with the latest from IAMHETHATIS
          </p>
        </div>

        {/* Bulletins List */}
        {bulletins.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-2xl text-[#737373]">No updates yet. Check back soon!</p>
          </div>
        ) : (
          <div className="space-y-8">
            {bulletins.map((bulletin) => (
              <div 
                key={bulletin.bulletin_id} 
                className="bg-gradient-to-br from-[#1A1A1A] to-[#0D0D0D] border-2 border-[#D4AF37] p-6 md:p-8"
              >
                {/* Date */}
                <div className="text-[#D4AF37] text-sm mb-3">
                  {formatDate(bulletin.created_at)}
                  {bulletin.updated_at && (
                    <span className="text-[#737373] ml-2">(Updated {formatDate(bulletin.updated_at)})</span>
                  )}
                </div>

                {/* Title */}
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                  {bulletin.title}
                </h2>

                {/* Media */}
                {bulletin.media_url && (
                  <div className="mb-6">
                    {bulletin.media_type === 'photo' ? (
                      <img 
                        src={bulletin.media_url} 
                        alt={bulletin.title}
                        className="w-full max-h-[500px] object-contain bg-black"
                      />
                    ) : bulletin.media_type === 'video' ? (
                      <video 
                        controls 
                        className="w-full max-h-[500px] bg-black"
                        poster={bulletin.media_url}
                      >
                        <source src={bulletin.media_url} type="video/mp4" />
                        Your browser does not support video playback.
                      </video>
                    ) : null}
                  </div>
                )}

                {/* Description */}
                <div className="text-white text-base md:text-lg leading-relaxed whitespace-pre-wrap">
                  {bulletin.description}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BulletinPage;
